import React from 'react'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useAuditRecord } from '../../../../../../shared/audit/history/audit-record-context'
import { useApiFormNodeCourseVersion } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleDateFormat } from '../../../../../../shared/form-simple/form-data-format'
import { ButtonSubmit } from '../../../../../../shared/form-simple/form-submit'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { FormSimpleJsonEditor } from '../../../../../../shared/form-simple/form-json-editor'

export const CourseNodeVersionEdit = () => {
  const { nodeCourseVersionID } = useParamsInt()
  // this course version's History, not the course's
  useAuditRecord({ type: 'node_course_versions', id: nodeCourseVersionID, role: { org: 'NODE' } })

  const apiFormNodeCourseVersion = useApiFormNodeCourseVersion()

  const handlePath = () => apiFormNodeCourseVersion.get(`${nodeCourseVersionID}`)

  const handleSubmit = async data => {
    await apiFormNodeCourseVersion.put(data.id, data)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text="edit" onPath={handlePath}>
        <CardFullHeightScrollY title="course version">
          <FormSimple state={apiFormNodeCourseVersion.form} onSubmit={handleSubmit} onRefresh={handlePath}>
            <FormSimpleDateFormat label="created" name="createdAt" />
            <FormSimpleDateFormat label="updated" name="updatedAt" />
            <FormSimpleJsonEditor name="metadata" />
            <ButtonSubmit text="save version" />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
